import React, { useState, useEffect,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
} from "reactstrap";
import { Formik } from "formik";
import PinInput from "react-pin-input";
import SvgImage from "../../Icons/Icons";
import "./index.css";
import * as Yup from "yup";
import { sendAnalitics } from "../../../services/Store/Actions/appActions";
import { payDriverSalaryAction } from "../../../services/Store/Actions/driverslistActions";
import { useParams } from "react-router-dom";
import { DatePickerField } from "../../core/inputs/input";
import moment from "moment";

function PaySalaryModal(props) {
  const dispatch = useDispatch();
  const {
    open,
    toggleModal,
    title,
    handleClick,
    handleClose,
    btn,
    balance,
    fastagBal,
    driverDetails
  } = props;
  const [startDate, setStartdate] = useState("");
  const datepickerRefEnd = useRef();
  const datepickerRefStart = useRef();
  const handleClickDatepickerIcon2 = () => {
    const datepickerElement = datepickerRefEnd.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };
  const handleClickDatepickerIcon1 = () => {
    const datepickerElement = datepickerRefStart.current;
    // console.log("datepickerElement = ", datepickerElement);
    datepickerElement.setOpen(!datepickerElement.open);
  };
  const { salaryWalletDetails } = useSelector(
    state => state?.driverlist,
  );
  const {id}= useParams();
  const validationSchema = Yup.object().shape({
    amount: Yup.number().typeError("Only Numbers are allowed")
      .required("Required")
      .min(1, "Amount should be greater than 1"),
    pin: Yup.string()
      .required("Required")
      .matches(/^[0-9]{4}$/, "Pin Must be exactly 4 digits"),
    lastSalaryDate: Yup.string().required("Salary Date is required"),
    workingDays : Yup.string().required("working Days is required"),
  });
  const {loader} = useSelector(
    (state) => state?.driverlist
  );

  // console.log("ok", props.fleetId);
  return (
    <div>
      <Modal
        isOpen={open}
        onHide={handleClose}
        className="positons1 settingModalMargin"
        toggle={toggleModal}
        aria-labelledby="myModalLabel2"
      >
         <div className="modal-content" style={{width:"530px", overflowY:"scroll", overflowX:"hidden"}} >
        <div className="modal-head-part">
          <p className="Add-balance-title">Pay Salary</p>
          <Button
            type="button"
            className="close-btn"
            onClick={toggleModal}
            aria-label="Close"
          >
            <SvgImage name="CloseButtonLogo" />
          </Button>
        </div>
        <ModalBody>
          {/* <div className="card-wallet-icon-body3">
            <SvgImage
              name="tollBooth"
              height="43.81"
              width="43.81"
              classname="card-wallet-logo-BankLogo"
            />
            <div>
              <p className="body-sub-part1">Fastag Wallet Balance</p>
              <p className="body-sub-part2">{"₹" + balance}</p>
            </div>
          </div> */}
          <Formik
            enableReinitialize
            initialValues={{
              amount: "",
              pin: "",
              lastSalaryDate: "",
              workingDays : "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              console.log("valllllllllll",moment(values?.lastSalaryDate).format("YYYY-MM-DD"));
              dispatch(
                payDriverSalaryAction(
                  {
                    phone : salaryWalletDetails.phone,
                    amount: values?.amount,
                    pin: values?.pin,
                    workingDays: values?.workingDays,
                    lastSalaryDate : moment(values?.lastSalaryDate).format("YYYY-MM-DD"),
                    single : 1
                  },
                  res => {
                    if (res?.type == "success") {
                      // dispatch(
                      //   fetchLastSalaryPayDetailsAction({}, res => {
                      //     if (res?.status == 200) {
                      //       console.log('here', res);
                      //       if (res?.data?.data?.initiated == 0 && res?.data?.data?.pending == 0) {
                      //         navigation.navigate('RedeemCashbackSuccess', {
                      //           salary: props?.route?.params?.amount,
                      //         });
                      //       }
                      //     }
                      //   }),
                      // );
                    } else {
                      // ToastAndroid.show(
                      //   res?.data?.message || 'error in creating request',
                      //   ToastAndroid.SHORT,
                      // );
                      // navigation.pop(3);4
                      console.log('salary not paidddddddddddddddddddd')
                    }
                  },
                ),
              );
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              isValid,
              errors,
              setFieldValue,
            }) => (
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <div className="sub-title-1">
                    <span class="circle-logo">1</span>
                    <label className="sub-head-3 ">Driver Name</label>
                  </div>
                  <div className="row">
                    <div className="col-10">
                      <p className="input-body-3 ">{salaryWalletDetails?.fullName}</p>
                    </div>

                    <div className="col-2">
                      <SvgImage name="lockLogo" />
                    </div>
                  </div>

                  <div className="input-amount-for-link"></div>
                  <p className="current-fastag-balance-for-recharge-wallet-id">
                    {`Early Salary Given: ₹ ${salaryWalletDetails.reImbursableAmount}`}
                  </p>
                </FormGroup>
                <FormGroup>
                  <div className="sub-title-1">
                    <span class="circle-logo">2</span>
                    <label className="sub-head-3 ">Contact Number</label>
                  </div>
                  <div className="row">
                    <div className="col-10">
                      <p className="input-body-3 ">{salaryWalletDetails.phone}</p>
                    </div>

                    <div className="col-2">
                      <SvgImage name="lockLogo" />
                    </div>
                  </div>

                  <div className="input-amount-for-link"></div>
                  {/* <p className="current-fastag-balance-for-recharge-wallet-id">
                    {`Early Salary Given: ₹ ${fastagBal}`}
                  </p> */}
                </FormGroup>
                <FormGroup>
                  <div className="sub-title-1">
                    <span class="circle-logo">3</span>
                    <p className="sub-title-recharge-fastag-Id">Enter amount</p>
                  </div>
                  <label for="html" className="label-body">
                    ₹
                  </label>
                  <input
                    type="text"
                    id="html"
                    className="input-body-1"
                    name="amount"
                    value={values.amount}
                    touched={touched.amount}
                    errors={errors.amount}
                    onBlur={handleBlur("amount")}
                    onChange={handleChange("amount")}
                    placeholder="Enter amount"
                  ></input>
                  <div className="input-amount"></div>
                  <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                    {errors.amount && touched.amount ? (
                      <div>*{errors.amount}</div>
                    ) : null}
                  </div>
                </FormGroup>
                <FormGroup>
                <div className="sub-title-1">
                    <span class="circle-logo">4</span>
                    <p className="sub-head-3">Enter Salart Date</p>
                  </div>
                  <label for="html" className="label-body">
                  </label>
                  <div className="custNamepadd3 row" style={{ width: "200px",marginLeft:"80px" }}>
                    <div className="col-9">
                      <DatePickerField
                        classname="searchBar-input1"
                        name="lastSalaryDate"
                        header="Select Start date"
                        value={values.lastSalaryDate}
                        onChange={(v) => {
                          setFieldValue("lastSalaryDate", v, true);
                          setStartdate(v);
                        }}
                        //onChange={(v) => setFieldValue("endDate", v, true)}
                        maxDate={
                          values.endDate === "" ? "" : values.endDate
                        }
                        // maxDate={new Date()}
                        ref1={datepickerRefEnd}
                        style={{ width: "300px" }}
                      />
                    </div>
                    <div className="col-3">
                      <label
                        className="date-input"
                        for="lastSalaryDate"
                        style={{
                          position: "relative",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleClickDatepickerIcon2();
                        }}
                      >
                        <SvgImage
                          name="CalenderLogo"
                          width="32"
                          height="32"
                          // classname="date-logo"
                        />
                      </label>
                    </div>
                  </div>
                  <div
                    className="heading4 Regular"
                    style={{ margin: "7px 0 0px 0", color: "red" }}
                  >
                    {errors.lastSalaryDate && touched.lastSalaryDate ? (
                      <div>*{errors.lastSalaryDate}</div>
                    ) : null}
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className="sub-title-1">
                    <span class="circle-logo">5</span>
                    <p className="sub-title-recharge-fastag-Id">Enter Working Days</p>
                  </div>
                  <label for="html" className="label-body">
                  </label>
                  <input
                    type="text"
                    id="html"
                    className="input-body-1"
                    name="workingDays"
                    value={values.workingDays}
                    touched={touched.workingDays}
                    errors={errors.workingDays}
                    onBlur={handleBlur("workingDays")}
                    onChange={handleChange("workingDays")}
                    placeholder="Enter working Days"
                  ></input>
                  <div className="input-amount"></div>
                  <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                    {errors.workingDays && touched.workingDays ? (
                      <div>*{errors.workingDays}</div>
                    ) : null}
                  </div>
                </FormGroup>
                <FormGroup>
                  <div>
                    <div className="sub-title-1">
                      <span class="circle-logo">6</span>
                      <p className="sub-head-4">Enter 4-digit Security Pin</p>
                    </div>
                    <p className="sub-head-body">
                      Security pin is needed to confirm payment
                    </p>
                    <PinInput
                      length={4}
                      initialValue=""
                      secret
                      onChange={handleChange("pin")}
                      type="numeric"
                      value={values.pin}
                      onBlur={handleBlur("pin")}
                      touched={touched.pin}
                      errors={errors.pin}
                      inputMode="number"
                      style={{
                        padding: "10px",
                        marginLeft: "96px",
                        marginTop: "28px",
                      }}
                      inputStyle={{
                        border: "1px solid #A7A7A7",
                        borderRadius: "8px",
                        marginRight: "20px",
                      }}
                      autoSelect={true}
                      regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                    />
                  </div>
                  <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                    {errors.pin && touched.pin ? (
                      <div>*{errors.pin}</div>
                    ) : null}
                  </div>
                  <div>
                    <button type="submit" className="butt-recharge" disabled={loader?true:false}
                      style={{marginTop:"60px"}}
                      onClick={() => {
                      dispatch(
                          sendAnalitics("salary_payment_to_driver", {
                          amt: values.amount,
                          pin: values.pin,
                        //   fleetId: props.fleetId
                          })
                        );
                      }}
                      >
                    {loader?"Please Wait":"Pay Salary"}
                    
                    </button>
                  </div>
                  
                </FormGroup>
                {/* <div className="space-div"></div> */}
              </Form>
            )}
          </Formik>
        </ModalBody>
        </div>
      </Modal>
    </div>
  );
}
export default PaySalaryModal;
